import { api } from '../../../api'
import {userInfo} from '../../MainAdmin/modules/main.js'


export const CHANGE_TEXT = 'CHANGE_TEXT'
export const ADD_DEVICE_MAC = 'ADD_DEVICE_MAC'
export const EDIT_DEVICE_MAC = 'EDIT_DEVICE_MAC'
export const DELETE_DEVICE_MAC = 'DELETE_DEVICE_MAC'
export const CHANGE_EMAIL_STATUS = 'CHANGE_EMAIL_STATUS'
export const EDIT_CLINIC_INFO = 'EDIT_CLINIC_INFO'
export const LOAD_DOCTOR = 'LOAD_DOCTOR'
export const RECEIVE_DOCTOR = 'RECEIVE_DOCTOR'
export const SNACKBAR_ON = 'SNACKBAR_ON'
export const SNACKBAR_OFF = 'SNACKBAR_OFF'



const onTextChange = (key, text) => {
  return {
    type: CHANGE_TEXT,
    payload: text,
    key
  }
}

const addDeviceMac = () => {
  return {
    type: ADD_DEVICE_MAC,
    payload: ""
  }
}

const editDeviceMac = (index, deviceMac, error) => {
  return {
    type: EDIT_DEVICE_MAC,
    payload: deviceMac,
    error,
    index
  }
}

const deleteDeviceMac = (id) => {
  return {
    type: DELETE_DEVICE_MAC,
    payload: id
  }
}

const emailStatusChange = (key, value) => {
  return {
    type: CHANGE_EMAIL_STATUS,
    payload: value,
    key
  }
}
function validatePhone(phone) {
    //var re = /^[\+]?[0-9]?[(]?[0-9]+[)]?[-\s\.]?[0-9]+[-\s\.]?[0-9]+$/im;
    //return re.test(phone);
	return true;
}
const editClinicInfo = (parentKey, childKey, value, doctorDetail) => {
  if(doctorDetail && parentKey === 'phone'){
    if(value.length < 8 || !validatePhone(value)) {
        doctorDetail.clinic.phoneInvalid = true;
    } else {
        doctorDetail.clinic.phoneInvalid = false;
    }
  }
  return {
    type: EDIT_CLINIC_INFO,
    payload: value,
    parentKey,
    childKey
  }
}

const receiveDoctor = (doctor) => {
  return {
    type: RECEIVE_DOCTOR,
    payload: doctor,
    isLoading: false
  }
}

const loadDoctor = (snack, id) => {
  return (dispatch, getState) => {
    dispatch({ type: LOAD_DOCTOR, payload: true })
    setTimeout(() => {
      dispatch({ type: LOAD_DOCTOR, payload: false })
    }, 3000);
    if(localStorage.access_token){
      api.get('/admin/doctors/' + id + '/detail', {} ,true)
      .then(response => {
        let resDoctor = response.doctor;

        localStorage.setItem('doctorDetail', JSON.stringify(resDoctor));
        dispatch(receiveDoctor(resDoctor));
        if(snack){
          let doctor = {...getState().doctorDetail}
          doctor.savedSnackbar = true;
          dispatch(SnackbarOn(doctor))
          setTimeout(function(){
            doctor.savedSnackbar = false;
            dispatch(SnackbarOff(doctor));
          }, 3000);
        }
      }, error => {
        // console.log(error);
      });
    }
  }
}

const SnackbarOn = (doctor) => {
   return {
    type: SNACKBAR_ON,
    payload: doctor,
    isLoading: false
  }
}

const SnackbarOff = (doctor) => {
  return {
    type: SNACKBAR_OFF,
    payload: doctor,
    isLoading: false
  }
}
function resolveNewMacs(macs){
  let arrFunc = [];
  macs.forEach(mac=>{
    arrFunc.push(checkDeviceExist(mac))
  })
  return Promise.all(arrFunc)
}

function checkDeviceExist(mac){
  return new Promise((resolve,reject)=>{
    api.post('/devices/check-mac', mac)
    .then(data=>{
      if(data.exists && data.device._id){
        return resolve(data.device)
      }
      resolve(mac)
    },err=>{
      reject(false);
    })
  })
}

const updateDoctor = (data) => {
  return (dispatch, getState) => {
    let newDevices = data.devices.filter(k => ((!k._id) && (k.mac)));
    let currentDevices = data.devices.filter(k => !!k._id);
    let doctor = {...getState().doctorDetail}
    dispatch({
      type: LOAD_DOCTOR, 
      payload: true
    })
    if (newDevices.length) {
      resolveNewMacs(newDevices)
      .then(resolveNewMacsResult=>{
        resolveNewMacsResult.forEach((item)=>{
          if(item._id){
            currentDevices.push(item);
          }
        })
        newDevices = resolveNewMacsResult.filter((item)=>{
          return !item._id;
        })
        api.post('/devices', newDevices , true)
        .then(result =>{
          result = result.devices;
          data.devices = [...currentDevices, ...result];
          
          api.put('/devices', data.devices, true)
          .then(d => {
            data.devices = d.devices.map(k => k._id); // just update mac _id
            api.put('/admin/doctors', { doctor: data } , true)
            .then(response => {
              dispatch(loadDoctor(true, data._id));
            }, error => {
              console.log(error);
            });
          })
        })
      },err=>{
        console.log(err);
      })

    } else {
      api.put('/devices', currentDevices, true)
      .then(d => {
        data.devices = d.devices.map(k => k._id); // just update mac _id
          console.log(data);
        api.put('/admin/doctors', { doctor: data } , true)
        .then(response => {
          dispatch(loadDoctor(true, data._id));
        }, error => {
          // console.log(error);
        });
      })
    }
  }
}


export const removeDeviceAPI = (payload) => {
  const { item, index } = payload;

  return (dispatch) => {
    api.delete('/devices', item)
    .then(res => {
      dispatch(deleteDeviceMac(index));
      console.log('Remove Device Response', res);
    }, err => console.log('Error Removing Device from API', err))
  }
}


const checkMacAddress = (mac, index) => {
  return (dispatch, getState) => {
    let doctor = {...getState().doctorDetail}
    //console.log(doctor.devices);
    let fff =doctor.devices.filter(device=>{
      return device.mac == mac.mac
    })
    if(fff.length > 1){
      dispatch(editDeviceMac(index, mac.mac, true))
      dispatch(onTextChange('isLoading',false));
      dispatch(onTextChange('formError', true));
      dispatch(onTextChange('errorSnack',true));
      dispatch(onTextChange('errorSnackMessage',"This MAC is already taken please try a new MAC"));
      setTimeout(function(){
        dispatch(onTextChange('errorSnack',false));
        dispatch(onTextChange('isLoading',false));
      }, 3000);
    }else{
      dispatch(onTextChange('formError', false));
    }
  }
}

const uploadAvatar = (data) => {
  return (dispatch, getState) => {
    let doctor = {...getState().doctorDetail}

    dispatch({
      type: LOAD_DOCTOR, 
      payload: true
    })

    
  }
}

const apiCreateMac = (data) => {
  return new Promise((resolve,reject)=> {
    api.post('/devices',data)
    .then(response => resolve(response.devices), err => reject(err))
  })
}

export const actions = {
  onTextChange,
  addDeviceMac,
  editDeviceMac,
  deleteDeviceMac,
  emailStatusChange,
  editClinicInfo,
  loadDoctor,
  updateDoctor,
  checkMacAddress,
  removeDeviceAPI,
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CHANGE_TEXT]: (state, action) => {
    return Object.assign({}, state, {
      [action.key]: action.payload
    })
  },
  [ADD_DEVICE_MAC]: (state, action) => {
    return Object.assign({}, state, {
      devices: [
        ...state.devices,
        {
          mac: "",
          active: true,
          sn: "sa"
        }
      ]
    })
  },
  [EDIT_DEVICE_MAC]: (state, action) => {
    return Object.assign({}, state, {
      devices: state.devices.map((device, index) => {
        if (index === action.index) {
          device.mac = action.payload
          device.edited = true,
          device.error = action.error
        }
        return device
      })
    })
  },
  [DELETE_DEVICE_MAC]: (state, action) => {
    let devices = state.devices.filter((item, index) => {
      if (action.payload != index) {
        return item;
      }
    })
    let error = false ;
    devices = devices.map((device)=>{
      let ddd = devices.filter(d=>{
        return d.mac == device.mac
      })
      if(ddd.length == 1){
        device.error = false
      }else{
        error = true;
      }
      return device;
    })
    return Object.assign({}, state, {
      devices: devices,
      formError : error
    })
  },
  [CHANGE_EMAIL_STATUS]: (state, action) => {
    return Object.assign({}, state, {
      email_pref: {
        wellness_check: Object.assign({}, state.email_pref.wellness_check, {
          [action.key]: action.payload
        })
      }
    })
  },
  [EDIT_CLINIC_INFO]: (state, action) => {
    if (action.childKey) {
      return Object.assign({}, state, {
        clinic: Object.assign({}, state.clinic, {
          [action.parentKey]: Object.assign({}, state.clinic[action.parentKey], {
            [action.childKey]: action.payload
          })
        })
      })
    } else {
      return Object.assign({}, state, {
        clinic: Object.assign({}, state.clinic, {
          [action.parentKey]: action.payload
        })
      })
    }
    
  },
  [LOAD_DOCTOR]: (state, action) => {
    return Object.assign({}, state, action.payload, {
      isLoading: action.payload
    })
  }, 
  [RECEIVE_DOCTOR]: (state, action) => {
    return Object.assign({}, state, action.payload, {
      isLoading: false
    })
  },
  [SNACKBAR_ON]: (state, action) => {
    return Object.assign({}, state, {savedSnackbar: true})
  },
  [SNACKBAR_OFF]: (state, action) => {
    return Object.assign({}, state, {savedSnackbar: false})
  }

}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  country: null,
  name: '',
  email: '',
  avt: '',
  google_calendar: '',
  devices: [
    {
      mac: '',
      active: false
    }
  ],
  tax_id: '',
  email_pref: {
    wellness_check: {
      three_months: false,
      one_month: false,
      day_of: false,
      week_after: false,
      month_after: false
    }
  },
  clinic: {
    name: "",
    phone: "",
    address: {
      street: "",
      street2: "",
      state: "",
      zip: "",
      city: "",
      country: ""
    }
  },
  savedSnackbar: false,
  isLoading: false,
  errorSnack: false,
  errorSnackMessage: "",
  formError: false
}
export default function settingReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/DoctorDetail/modules/doctorDetail.js